module.exports = __webpack_public_path__ + "static/img/bcg.85a8e206.png";